"use client";
import { HeroBannerSection } from "@/components/reviews/hero_banner_section";
import { EveryoneAgreesSection } from "@/components/reviews/everyone_agrees_section";
import { RealCustomersSection } from "@/components/reviews/real_customers_section";
import { Stack } from "@mui/material";

export default function ReviewsPage() {
  return (
    <Stack>
      {/* Hero Banner Section */}
      <HeroBannerSection />

      {/* Everyone Agrees That Section */}
      <EveryoneAgreesSection />

      {/* From Our Real Customers Section */}
      <RealCustomersSection />
    </Stack>
  );
}